module.exports = __webpack_public_path__ + "static/media/Jia_Johnson.75c4a422.jpg";